import { User } from '../models/user.model';

export type AuthState = {
  _authToken: string | null;
  _user: User | null | undefined;
};

export const initialState: AuthState = {
  _authToken: null,
  _user: undefined,
};
